export const filterSearchDefaultLimit = 50;

export const SEARCH_MODES = {
  SCOPED: 'scoped',
  FULL: 'full',
} as const;

export type SearchMode = (typeof SEARCH_MODES)[keyof typeof SEARCH_MODES];
